var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.948 18.652c.217 0 .33.165.318.3-.272 3.117-1.82 6.089-4.65 7.54-.517.264-1.278.462-2.189.597-.898.133-1.89.198-2.833.223a42.286 42.286 0 01-3.75-.076c-.365-.078-.466-.182-.501-.226-.05-.064-.094-.171-.138-.455l-.026-.178c-.076-.553-.195-1.409-.989-2.195a9.181 9.181 0 01-2.545-4.715 9.12 9.12 0 01.529-5.318c.157-.375.303-.756.45-1.142.234-.61.472-1.233.766-1.862.461-.988.976-1.785 1.605-2.241 1.35-.34 2.26-.288 3.404-.223.166.01.337.02.514.028a.407.407 0 01.396.392v7.73c0 1.006.816 1.821 1.822 1.821h7.817z",
    fill: "#F3F6F8",
    stroke: "#9CACC0",
    strokeWidth: 1.381
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.771 18.75c.136 0 .25.055.322.13a.3.3 0 01.087.254A9.25 9.25 0 1110.866 8.82a.3.3 0 01.254.087c.075.072.13.186.13.322v7.542c0 1.093.886 1.979 1.979 1.979h7.542z",
    fill: "#fff",
    stroke: "#9CACC0",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.757 4h-1.841l6.845 12h2.15c1.265 0 2.309-.968 2.155-2.224-.3-2.449-1.447-6.37-5.54-8.869C23.404 4.222 22.072 4 20.756 4z",
    fill: "#38B4E5",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.364c0-1.419 1.008-2.594 2.218-2.325.7.155 1.388.384 2.051.685a11.145 11.145 0 013.62 2.646 12.34 12.34 0 012.417 3.96c.26.687.462 1.397.604 2.121.27 1.385-.753 2.549-1.986 2.549h-6.692C17.998 16 17 14.85 17 13.43V6.365z",
    fill: "#5DCDFA"
  })));
}
export default SvgDashboard;